import { TextInput as MantineTextInput, TextInputProps } from "@mantine/core"
import { forwardRef } from "react"

import { Loader } from "@tfg/ui"

type Props = {
  isLoading?: boolean
} & TextInputProps
export const TextInput = forwardRef<HTMLInputElement, Props>(
  ({ isLoading, ...props }, ref) => {
    return (
      <MantineTextInput
        ref={ref}
        rightSection={isLoading ? <Loader size="xs" /> : undefined}
        {...props}
      />
    )
  }
)

TextInput.displayName = "TextInput"
